// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown[data-v-4c02582f]{align-items:flex-end;display:flex;flex-direction:column}.dropdown-button[data-v-4c02582f]{cursor:pointer;padding:0 10px}.dropdown-list[data-v-4c02582f]{background-color:#fff;border:1px solid #e4e4e4;border-radius:8px;cursor:pointer}.dropdown-list span[data-v-4c02582f]{display:inline-block;padding:10px}.dropdown-list[data-v-4c02582f]:hover{box-shadow:0 10px 34px 0 hsla(0,0%,82%,.5)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
